import React, {Component} from 'react';

export default class ToggleView extends Component {
  constructor(props) {
    super(props);
    this.state = {value:true}

    this.showGrid = false;
  }

  handleClick = () => {
    this.showGrid = !this.showGrid;

    this.props.onChange(this.showGrid);
  }

  render() {
    return(
      <div className="toggle-wrapper">
        <div className="button" onClick={this.handleClick}>
          {`${this.showGrid ? "Grid View" : "List View"}`}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/toggleView.js